export default function Services() {
  const services = [
    {
      title: 'Office Solutions',
      description: 'Perfect for corporate environments',
      image: 'https://public.readdy.ai/ai/img_res/5f70a82d5489865a03422ae65d8e6e33.jpg',
      price: 'From $299/month'
    },
    {
      title: 'Fitness Centers',
      description: 'Healthy options for active lifestyles',
      image: 'https://readdy.ai/api/search-image?query=Smart%20vending%20machine%20in%20modern%20fitness%20center%20gym%20environment%2C%20athletic%20equipment%20visible%2C%20bright%20energetic%20atmosphere%2C%20health-focused%20product%20display%2C%20contemporary%20sports%20facility%20interior%2C%20automated%20healthy%20snack%20dispenser%20with%20digital%20screen%2C%20clean%20simple%20background%20with%20gym%20equipment&width=800&height=800&seq=service-fitness&orientation=squarish',
      price: 'From $349/month'
    },
    {
      title: 'Residential Buildings',
      description: 'Convenient amenities for residents',
      image: 'https://readdy.ai/api/search-image?query=Modern%20AI%20vending%20machine%20in%20upscale%20apartment%20building%20lobby%2C%20elegant%20residential%20interior%20design%2C%20contemporary%20amenity%20space%2C%20sophisticated%20automated%20retail%20solution%2C%20luxury%20living%20environment%2C%20touchscreen%20smart%20kiosk%2C%20clean%20simple%20background%20with%20modern%20furniture&width=800&height=800&seq=service-residential&orientation=squarish',
      price: 'From $279/month'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Solutions</h2>
          <p className="text-xl text-gray-600">Intelligent vending tailored to your business needs</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative rounded-3xl overflow-hidden cursor-pointer hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl"
              style={{ height: '500px' }}
            >
              <div className="absolute inset-0 w-full h-full">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8 text-center">
                <h3 className="text-3xl font-bold text-white mb-2">{service.title}</h3>
                <p className="text-lg text-white/90">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-24 bg-gray-100 rounded-3xl p-16 text-center">
          <div className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-bold mb-6">
            <i className="ri-gift-line"></i> NO COST · NO MAINTENANCE · ALWAYS STOCKED
          </div>
          <h3 className="text-5xl font-bold text-gray-900 mb-4">Ready to Upgrade Your Space?</h3>
          <p className="text-xl text-gray-600 mb-4">Join New Jersey businesses enjoying our AI coolers — <strong>completely free</strong></p>
          <p className="text-base text-gray-500 mb-8">We provide the machine, stock it regularly, and handle all maintenance. You pay nothing.</p>
          <button className="bg-amber-900 text-white px-12 py-4 rounded-full text-lg font-medium hover:bg-amber-800 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
            Get Your Free Cooler
            <i className="ri-arrow-right-line"></i>
          </button>

          {/* Product Showcase */}
          <div className="mt-12 flex items-center justify-center gap-8 flex-wrap">
            <img 
              src="https://readdy.ai/api/search-image?query=Premium%20black%20and%20silver%20AI%20vending%20machine%20with%20curved%20edges%20and%20holographic%20display%20panel%2C%20futuristic%20design%20elements%20with%20blue%20accent%20lighting%2C%20sophisticated%20automated%20beverage%20cooler%2C%20floating%20on%20gradient%20background%20with%20soft%20shadows%2C%20ultra-modern%20product%20photography&width=200&height=300&seq=showcase-product-1&orientation=portrait"
              alt="Vending Machine 1"
              className="h-48 object-contain"
            />
            <img 
              src="https://readdy.ai/api/search-image?query=Compact%20white%20and%20chrome%20smart%20refrigerated%20kiosk%20with%20transparent%20glass%20door%2C%20LED%20strip%20lighting%20around%20edges%2C%20minimalist%20rectangular%20design%20with%20wireless%20payment%20symbol%2C%20pristine%20white%20studio%20background%20with%20subtle%20reflections%2C%20premium%20product%20visualization&width=200&height=300&seq=showcase-product-2&orientation=portrait"
              alt="Vending Machine 2"
              className="h-48 object-contain"
            />
            <img 
              src="https://readdy.ai/api/search-image?query=Tall%20cylindrical%20AI%20beverage%20tower%20with%20spiral%20product%20display%20visible%20through%20clear%20acrylic%20panels%2C%20robotic%20arm%20mechanism%20inside%2C%20orange%20and%20gray%20color%20scheme%2C%20sci-fi%20automated%20dispenser%20concept%2C%20clean%20geometric%20background%20with%20light%20beam%20effects&width=200&height=300&seq=showcase-product-3&orientation=portrait"
              alt="Vending Machine 3"
              className="h-48 object-contain"
            />
            <img 
              src="https://readdy.ai/api/search-image?query=Modular%20cube-shaped%20smart%20vending%20unit%20with%20matte%20green%20finish%20and%20golden%20accents%2C%20multiple%20compartment%20doors%20with%20individual%20screens%2C%20stackable%20design%20concept%2C%20eco-friendly%20automated%20retail%20solution%2C%20soft%20natural%20lighting%20on%20neutral%20beige%20background&width=200&height=300&seq=showcase-product-4&orientation=portrait"
              alt="Vending Machine 4"
              className="h-48 object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}